import styled from "styled-components"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtPackage } from "server/models"
import { deepCopy, useInput } from "client/utils"
import {
    StoreType,
    PackageSettings,
    PackageList,
    setPackageList,
} from "client/store"
import { Input } from "client/components"


const TableInputStyled = styled(Input)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`

interface InputProps {
    data: string | number
    type: "text" | "integer" | "float"
}

const TableInput = ({
    data,
    type,
}: InputProps) => {
    const packageList = useSelector((state: StoreType) => state.package.packageList)
    const activeCell = useSelector((state: StoreType) => state.package.activeCell)
    const dispatch = useDispatch()

    const [value, setValue] = useInput(data.toString() || "")

    useEffect(() => {
        const input = document.querySelector(TableInputStyled) as HTMLInputElement
        input.focus()
        input.select()
    }, [])

    useEffect(() => {
        let val = ""
        if (type === "text") val = value
        if (type === "integer") {
            const parsedValue = parseInt(value, 10)
            if (parsedValue > 0) val = parsedValue.toString()
            else val = "0"
        }
        if (type === "float") {
            const parsedValue = parseFloat(value)
            if (parsedValue > 0) val = parsedValue.toFixed(2)
            else val = "0.00"
        }

        const { packageId, column } = activeCell
        const packageListCopy: PackageList = packageList ? deepCopy(packageList) : {}
        const packg = packageListCopy[packageId]

        const packageProperty = column as keyof MtPackage
        const packageSetting = column as keyof PackageSettings

        if (packg[packageProperty] !== undefined) {
            packageListCopy[packageId] = {
                ...packg,
                [packageProperty]: val,
            }
        }
        if (packg.settingsParsed[packageSetting] !== undefined) {
            packageListCopy[packageId] = {
                ...packg,
                settingsParsed: {
                    ...packg.settingsParsed,
                    [packageSetting]: val,
                },
            }
        }

        dispatch(setPackageList(packageListCopy))
    }, [value])

    return (
        <TableInputStyled type="text" value={value} onChange={setValue} />
    )
}
export default TableInput
